interface BrandProps {
  size?: "md" | "lg";
}

export function Brand({ size = "md" }: BrandProps) {
  const className = size === "lg" ? "brand brand--lg" : "brand";
  const iconSize = size === "lg" ? 18 : 12;
  return (
    <span className={className}>
      <span className="brand__mark" aria-hidden>
        <svg
          width={iconSize}
          height={iconSize}
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 8.5l3.2 3.2L13 4.8"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
      <span className="brand__word">Placet</span>
    </span>
  );
}
